import styles from './PromotedCard.module.css'
import styleUtils from 'shared-components/styles/util.module.css'
import clsx from 'clsx'
import AppImage from 'shared-components/ui/AppImage'
import Check from 'shared-svg/Check.svg'
import OfferButtonLink from 'shared-components/buttons/OfferButtonLink'
import { ThemeContext } from 'shared-components/contexts/ThemeContext'
import AwardLabel from 'shared-components/ui/AwardLabel'
import type { VFC } from 'react'
import type { DSPromotedProduct } from 'shared-definitions/types'

interface PromotedCardProps {
  className?: string
  data: DSPromotedProduct
}

const PromotedCard: VFC<PromotedCardProps> = ({ className, data }) => {
  const { theme } = ThemeContext.useContainer()

  if (!data) {
    return null
  }

  return (
    <div className={clsx(styles.container, { [styles.darkTheme]: theme === 'dark' }, className)}>
      <div className={styles.wrapper}>
        {data.image && (
          <div className={styles.imageWrapper}>
            <AppImage
              image={data.image}
              className={styles.img}
              layout="fill"
              sizes={[
                { bp: 'lg', val: 210 },
                { bp: 'sm', val: 'calc(50vw - rem(30))' },
                'calc(100vw - rem(30))',
              ]}
            />
          </div>
        )}
        <div className={styles.heading}>
          <h3 className={clsx(styleUtils.cutoffText, styles.title)}>{data.title}</h3>
          <span className={clsx(styleUtils.cutoffText, styles.excerpt)}>{data.excerpt}</span>
        </div>
        <div className={styles.features}>
          <div className={styles.featuresWrapper}>
            {data.features.map(item => (
              <div className={styles.featuresItem} key={item}>
                <span className={styles.itemContent}>{item}</span>
                <div className={styles.itemIcon}>
                  <Check className={styles.icon} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.advertise}>
          {data.awardLabel && <AwardLabel label={data.awardLabel} className={styles.label} />}
          <OfferButtonLink
            target="_blank"
            className={styles.offerBtn}
            href={data.advertiseButton.pLink.href}
          >
            <span className={styleUtils.cutoffText}>{data.advertiseButton.label}</span>
          </OfferButtonLink>
        </div>
      </div>
    </div>
  )
}

export default PromotedCard
